import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M22 6h-5v5h-5v5h-5v5h-5","key":"svg-0"}],["path",{"d":"M6 10v-7","key":"svg-1"}],["path",{"d":"M3 6l3 -3l3 3","key":"svg-2"}]]

/**
 * IconStairsUp
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItc3RhaXJzLXVwIgo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik0yMiA2aC01djVoLTV2NWgtNXY1aC01IiAvPgogIDxwYXRoIGQ9Ik02IDEwdi03IiAvPgogIDxwYXRoIGQ9Ik0zIDZsMyAtM2wzIDMiIC8+Cjwvc3ZnPg==) - https://tabler.io/icons/icon/stairs-up
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconStairsUp = createReactComponent('outline', 'stairs-up', 'StairsUp', __iconNode);

export default IconStairsUp;